'use client';

import { useIntl } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import styles from './LastUpdated.module.scss';

function lowerDayPeriod({ type, value }) {
  switch (type) {
    case 'dayPeriod':
      return value.toLowerCase();
    default:
      return value;
  }
}

type LastUpdatedProps = {
  updatedAt: string;
};

const LastUpdated = ({ updatedAt }: LastUpdatedProps) => {
  const intl = useIntl();
  const updated = new Date(updatedAt);

  let formattedDate;
  try {
    formattedDate = intl
      .formatDateToParts(updated, {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        timeZoneName: 'shortGeneric'
      })
      .map(lowerDayPeriod)
      .join('');
  } catch {
    formattedDate = intl
      .formatDateToParts(updated, {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        timeZoneName: 'short'
      })
      .map(lowerDayPeriod)
      .join('');
  }

  return (
    <Typography className={styles.lastUpdatedText} component="div" variant="text100">
      <span suppressHydrationWarning>{intl.formatMessage({ defaultMessage: 'Last updated on {date}' }, { date: formattedDate })}</span>
    </Typography>
  );
};

export default LastUpdated;
